import React from 'react'
import FontFile from '../shared/font-file'


const Word = (props) => { 
  return <FontFile 
            font={'graphic'} 
            topOffset='0em'
            multiplier={1}
            {...props}
            borderColor={props.backCol} 
          />
}

export default Word